import React from "react"
import Snackbar from "@material-ui/core/Snackbar"

import { AppActions } from "../../../store/actions"
import {
  NOTIFICATION_ANCHOR,
  NOTIFICATION_AUTOHIDE_DURATION,
} from "../utils/contstants"

const Notification = props => {
  const appActions = AppActions()
  const { open, message } = props

  const handleClose = () => appActions.hideNotification()

  return (
    <Snackbar
      anchorOrigin={NOTIFICATION_ANCHOR}
      autoHideDuration={NOTIFICATION_AUTOHIDE_DURATION}
      onClose={handleClose}
      open={open}
      message={message}
    />
  )
}

export default Notification
